var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-preview-page"},[_c('CoursePreview',{attrs:{"course":_vm.course}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }